export default __webpack_public_path__ + "static/media/013-hippopotamus.203b1288.svg";